// Featured passages from "A Love Letter To Humanity" by King Spiros of Plomari
// Expanded collection with passages from The Mushroom Seamstress (820 pages)

export const featuredPassages = [
  {
    text: "Human history is like a house of cards, and Plomari is designed to blow it down. This doesn't mean the world will vanish or end; it simply marks the end of bullshit and the beginning of paradise.",
    source: "The Wind That Topples the House of Cards"
  },
  {
    text: "The Kingdom of Plomari is your world. The Plomarians are your people. You can live for yourself today, or help build tomorrow for everyone.",
    source: "Welcome to Plomari"
  },
  {
    text: "One reason we created The Kingdom of Plomari is simple: To make sure the sacred knowledge of the magic mushroom is never lost. Plomari is not just a sanctuary for today—it's a culture of remembrance.",
    source: "A Love Letter To Humanity"
  },
  {
    text: "Breathe Plomari Eternity, You'll never breathe alone. This time we'll all be Souls of Endless Love.",
    source: "The Creation of Plomari"
  },
  {
    text: "When the house of cards collapses, what remains is truth. What emerges is a world no longer shackled by the weight of outdated ideologies.",
    source: "The Wind That Topples the House of Cards"
  },
  {
    text: "A paradise, not promised, but built. Not dictated, but discovered. Plomari is not just an idea. It is a force. A whisper turning into a roar.",
    source: "The Beginning of Paradise"
  },
  {
    text: "The thing is, the whole Universe is in peace. No one is rushing, pushing or worrying. Except humans. That's why we don't worry here in Plomari.",
    source: "Welcome to Plomari"
  },
  {
    text: "Spiros  takes  his  diary  and  runs  down  to  an  inter net  café nearby. He logs on to the ruling  running  quantum  di-hybridal spacial  encompassing  chat  room  (The  Deoxyribonucleic",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "Hyperdimension) and begins to type cryptic messages, inspired, uncontrollably. Masses of water vapour, clouds, come in toward the mountain  he is  on, from three directions,  and whitepurple",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "flashes of lightning light up the immediate area. A  woman  turns  toward  Spiros  and  looks  at  him  with frightened eyes. ―That  look  you  just  gave  me,  she  says.  It  came  from",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "somewhere else… She steps out into the rain. Spiros writes on the chat: You’re scaring me You’re scaring me to death I feel a weakness coming on",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "Sissy Cogan sees Spiros’ words on the chat. ―Ohoh, she says. Someone call the air-pirates. Magus and Dead McJones turn up on the chat and ask Spiros",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "who he is, to which Spiros responds: ―Ban him, Magus says to Dead McJones who knows exactly Spiros continues to rave on the chat: ―Serverside implement membership protected area consists",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "chat under Spiros’ line: ―See, I’m not alone. We are coming from elsewhere. Bzzz! Bzzzzzzzz! Bzzzzzzzzzzzzzzz! ―Tell them we don’t sting, says Sissy Cogan. Nykkel Humphry, friend  of Magus  and Dead McJones and",
    source: "The Mushroom Seamstress, Page 37"
  },
  {
    text: "The phone rings. Spiros answers. No one is there. ―It’s hidden, Spiros says. The door. Dear, show yourself more He  gasps  for  air,  rememb ers:  The  potential  for  alchemical",
    source: "The Mushroom Seamstress, Page 45"
  },
  {
    text: "dream, born from a dreamshadow. He casts off his clothes and stands naked in the alchemical mess of his imagination. A flock of two hundred birds comes flying towar d the house. He hears the",
    source: "The Mushroom Seamstress, Page 45"
  },
  {
    text: "sound of their flapping wings and the sharp sound of their turns as  they  fly  close  to  the  windows.  They  settle  down  in  trees ―Dreambirds, Spiros says in awe and looks out the window. I",
    source: "The Mushroom Seamstress, Page 45"
  },
  {
    text: "had forgotten you! Too drunk to see my mates! A bird  flies  by the window  and snaps  a lock of here from Spiros’ shadow. ―Are you ready? asks a voice.",
    source: "The Mushroom Seamstress, Page 45"
  },
  {
    text: "A sign at platform 6 reads, beside an arrow:  Land Of Make Believe. Beside it is a commercial depicting a yellow water post formed like an elf, by the text: They Exist. Spiros follows the sign",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "into the main hall of Central Station, Old Town’s main railway The position of books are switched in the bookshop behind him. He turns his face and in his field of vision sees a woman as",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "she  almost  unnoticeably  licks  the  mouth-end  of  a  long  white cigarette holder, moving it for a puff. ―Yes and where better to hide it than in lives like ours? Spiros",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "hears her say as she talks in a mobile phone. The woman casts a quick eye toward Spiros, then says: ―We’re as close as we can get at the moment.",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "A man beside Spiros overhears the woman’s conv ersation too, and seems to be experiencing something strange. He turns toward Spiros and says with fear and panic in his voice:",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "computer screen. ―That’s not erotic, he says. ―How is that not erotic? says the Supervisor. She’s straddling ―True, Nykkel laughs. Spiros writes on a wall with a red marker:",
    source: "The Mushroom Seamstress, Page 53"
  },
  {
    text: "on  to  wherever  you  want  to  go.  On  to  the  other  worlds,  for instance  the  newuniversal  structure  of  the  future  (Alien), Yourowndreamland,  The  City  of  the  Dead,  the  City  of  No",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "Addresses,  and  all  those  places.  Plomari.  Steal  back  your prophethood of chaos like the perfect erocriminal you are. Sissy Cogan jumps up onto a rock and says to her imaginary",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "―Most  dearly  beloved,  friends  and  family.  We  have constructed pyramids in honor of our escape.  Children, excuse us that we did not tell you earlier. The river contains specimens.",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "can imagine them. Don’t be fooled by dull mind. Be a prism. Write your own universe. The birds listen. They look at our dear Sissy as she stands in",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "victory on a rock on loving Earth by the mighty river. And they laugh at how cute she is. It’s those girlish green eyes of hers, so",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "girlish and yet so ancient a nd deep and motherly, in them or from them shines all the ages and a secret so strange and happy that only a god could have figured such a marvellous thing. ―We fell on a bumpy road! a bird laughs. That’s what history",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "―Whoops! Sissy laughs. ―Can someone make us shut up about it! cries another bird. ―No! We shall disclose all the secrets! says Sissy. Sissy sits down by a large tree just at the edge of the river and",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "looks  out  across  the  grass.  With  swiftly  moving  eyes  and  the corners of her mouth twitchi ng in smiles she writes in her diary the words of William Butler Yeats in his Sailing to Byzantium.",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "―Gather  me,  she  whispers.  Merge  me  into  the  artifice  of A sharp-winged phoenix flies through her eyes. Rays of the Star Eagle shimmer along her ey elashes and she blinks happily.",
    source: "The Mushroom Seamstress, Page 61"
  },
  {
    text: "This time we’ll all be souls of endless love Endless love, love that holds the cosmos together like some kind  of  glue.  Spiros  was  up  in  the  timeweb  that  day.  The",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "timestretch,  where  the  plasticity  of  time  is  so  apparent.  And people were screaming “Here we go, here we go, get ready, here it comes!” Pop-pop sounds and fireworks at the end of history, in",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "hyperspace. His immediate surroundings, the walls and the whole house, crackled with small chirping sounds, chisting sounds, pop, pop,  poppo,  as  though  the  world  was  about  to  hyperdimens- ionally fold up into some new dimension and was breaking apart. Spiros thought it was time to depart to hyperspace, but it hadn’t",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "been, it seemed. Soon he had found himself back in his ordinary mindset and everything seemed as usual. Or maybe I really did leave, Spiros thinks. Maybe I am on new",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "All the shamans were there. All of them, with their minds up in the timeweb. Here comes everybody. And the bibs are free! He is reminded of the letter in the book Fit to Talk a Dream:",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "time― to life! Does anyone remember how we got  here?  Everyone  everyyear,  consult  the ministering angels about it. From the big team of Saucers and the one",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "(Meet us anywhere in at Junction) Spiros has a hard time understanding what is happening but he  is  beginning  to  understand  it  like  a  storyteller  begins  to",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "understand the intricacies of his plot. Sissy: sorceress, most dead of witches, and somehow she is connected to the alien. She comes 4 Let us all hope this word does not mean anything particular.",
    source: "The Mushroom Seamstress, Page 69"
  },
  {
    text: "down their glasses on the ground, and Sissy slid her hands up Spiros back and into his hair and Spiros squeezed her against him and scanned her face with his eyes and she felt his heavy body",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "steady against her. Sissy lies on the grass in tipsy bliss. …and you grabbed my hair and dove into my neck and bit me there gently but with force and squeezed me tighter as I wrapped",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "my  arms  around  you.  Leaves  fell  soundlessly  through  the  air around us and made like little boats on the river’s surface and the wind  wift  the  trees  as  I  let  my  white  dress  fall  slowly  to the",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "ground  letting  my  naked  bodhy  out  into  the  open  and  I unwrapped the bed sheet from around your waist and we stand holding each other just feeling the wind and our skin together we look around at all the beauty and I jump up on you and hang",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "around your hips and my breasts against your chest and we hug tight together and laugh as the sun bursts through the treetops to heat our skin and we run down to the river and dive into the clear Our  plan  worked,  my  dearest.  Unincarnadine  dawn  arisen.",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "Spiros  lets  the  question  float  around  in  his  world.  Clouds, chryssanthial5 fluffy  surreal  clouds,  lie  across  the  dome  of  the sky― he sees them through the window. The clouds, painted in",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "the dome of the outside of my head. And here I am, in the world you can bend with your smile. The wunderdome. I am not the",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "first to enter. Nor am I the last. Hoorray! He sits down by the computer terminal and checks the trash bin of his email inbox for spam emails, something he does often in",
    source: "The Mushroom Seamstress, Page 77"
  },
  {
    text: "Yesterday I bathed in the silver river with the moon big and grey and close enough that I could touch it with  my  fingers.  The  young  Springmoon  she’s",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "now, in the world after time. The sun and moon are with us all, beaming love for us! I shall rise from the ashes of modernity, like good old",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "Don't you believe enough? Spiros slams his hand on the table in laughter. ―Want to be Phoenixed ? Come and be parked! He  closes  the  diary,  pressing  a  few  rose  petals  within  its",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "pages, and wraps it in its red silk cover. Happily he begins to make his way to the sea. The sea, the pool, where the river comes out. At the end of the",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "river lies a world so magical it cannot be imagined from here. I am making my way into it, slowly but steadily. Slowly, but steadily. In to the world I have no name for. The",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "world with the happy kiss. Everything means something in that first hall, where one is welcomed. Layer upon layer of strange alchemical meaning. The rose, the river, the bird that flies away",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "from the grave, the sun and the moon and the old sundial. It looks like your ordinary palace, but then you begin to notice the kinks: the wet naked roses, the blood red wine, the rattles made of dead bone, death and life and love in a love scene in public on centre stage, the deep church music and the smell of sex and incense. Someone has gone off the far end, you think. And then another",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "veil; a curtain in the dark diamondstarry sky. Divinely silly and deep. Behind it you find the happy summer garden where young Byzantine women and men walk around naked, swooning in love",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "on  the  green  grass,  intelligent  birds  singing  around  them, dragonflies like small helicopters filming the area in 3D: you flow into it like a dream. And biology in love with technology creating",
    source: "The Mushroom Seamstress, Page 85"
  },
  {
    text: "pulsating with perpetual kindness; existence is a reflection of the immense splendor and love of Thy conscious spirit. Butterfly looks at Spiros. ―O and Spiros, she says.",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "―I have thought of another name for the play as well.  The Crime of the Dove & the Crossador. A quick dove flies by. Spiros’ eyes turn deep, as though he",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "suddenly remembers something. ―The infection, says Sissy and hands over the gem. It has begun. ―May the rosy dream interblend with reality. Butterfly rises and cracks another beer, takes a sip and toasts the",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "starry sky and toasts Spiros. Stately like the Aeon she begins to ―I am a singularity as a totality, but what of our substrate? This fruit will fall and rot, but the tree is the one who grew and",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "experienced me. The fruit dies every second, but realize the tree and  you  will  become  eternal  life.  Inward,  a point  of existence twisted into singularity, yet no one realizes the starting point: our",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "one virginal womb, the dwelling place of God. She lights a joint and invites Spiros to play out a little scene from the movie The Wonderland Experience .",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "―It’s not an immediate concern for us then. Butterfly passes the joint. ―I love that movie, says Spiros. ―Loosin’ my marbles! Ye s sir! ―Fuck. The underlying principle…",
    source: "The Mushroom Seamstress, Page 93"
  },
  {
    text: "here in the little adobe house by the dark black river. I have planted a seed at the center of the house on the earthfloor. It will  bring  me fruits  for flight to",
    source: "The Mushroom Seamstress, Page 101"
  },
  {
    text: "you. The smoke-phone works. Navigate through the rosy dream that we may find each other again!11 Wine is spilled on the letter, still wet. Spiros licks the wine and",
    source: "The Mushroom Seamstress, Page 101"
  },
  {
    text: "Blame my dark lover as Spiros would have her called. It is taking time  however,  we’ve  been  busy  with  living  and  with communicating with Saussie Love. Now she’s put a pen in our",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "hands and cruises under it like only she can. (Adam’s and  Mary’s  opus in its  current  form is brought  forth  and scrutinised by a large group of people. )",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "A VOICE: But Adam, Mary, your book is horrible. Poorly written, delirious, boring. Burn the Godforsaken script and stop wasting your time, and our time, your supposed readers.",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "VOICES: Book-burning! Book-burning! We want to see a book- ADAM: We’re not trying to write a book. We are building a devise that we shall use to shatter our ordinary mind and enable entry",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "into home sweet home once and for all. Hyperspace, you know, the  thing  every  single  word  is  about.  The  City  of  the  Dead. Elsingard, the city of no addresses. A city called Sphinx. Alien",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "we are here; working from both sides at once. From wikawades world we are passing…? PERNELLE FLAMEL: The This-Side Undertaking. You are being MARY BRISCOLL: We are inside these dreams to fix a few things.",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "We are the Fixers. With P H. Phixers. ( She mumbles.) The sunny union, can it be too close to the? ( She takes a sip of Spice. ) See, we",
    source: "The Mushroom Seamstress, Page 109"
  },
  {
    text: "MR LANGINER: (To Kick and Krint.) Can you code this? ( He hands over a mobile phone.) KRINT FRINREY: I can code whatever. Give me a micro sensor,",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "some language, a compiler, and something like the output of a fuel pump if you want, and I'll code it. ( In the phone.) Find out if",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "way for them to track this. (The  Saga,  the  Play,  opens  with  a  kiss  across  the  vast  expanses  of Hyperspace. It is springtime, and the Lovers are dripping wet with the",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "ecstasy. The divine breasts of the Sisters giveth the Milk of Everything through  the  impossible  tangle  of  hyperspace,  with  ease,  into  the cybernetic eternal matrix. Mother Conception whispers about the virgin",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "birth. The sisters kiss. Bianca, disguised as a Cupid angel, shoots a dart of love into alls their hearts. The dart is a ray of light and opens up the",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "Myths of the Past and all the gods wake up in the wondrous dream. Sissy sings in the waters of the living vision, and they all drift in mad",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "joy  within  their  sweet  complexion,  their  impossible  birth.  Suns  and atoms  shake  violently as  they cannot  decide whether to  be atoms  or electrons or suns. Black holes suck the future into the eyes of the Gods.",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "The  secret  sacrament  is  hidden  as  a  mushroom  on  the  pastures  of Heaven.  The  good  Satan  and  his  seven  wives  sneak  into  history unnoticed, from their secret abode which is spread out and impossible to",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "locate. The Secrets are spread out across the earth, delivered by the angel messengers. Jenny Fur and Spiros spill. (Spill inte nu Jenny) A book containing many of the secrets, is published. Spiros falls",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "through the golden mouth of the Egyptian sarcophagus of the Eternal union.  He  wakes  up  in  the  secret  world  of  Plomari.  The  parallel universes of the Secret intersect in one lovely story: the best story ever.",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "Spiros finds himself caught in the spook house by the river. The house has been completely trashed by to him invisible party people. He has found a letter and also a corset that he recognises. The smell of nail",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "polish fills the room.) BIANCA:  (Makes  little  noises  as  she  twitches  in  a  few  small  bird sneezes, little drops of saliva shooting off her pink beak. ) Becc. Becc.",
    source: "The Mushroom Seamstress, Page 117"
  },
  {
    text: "SPIROS: Well this calls for celebration. Good seeing you fellows again. When begins the sexy attack? ANNA LURIA (a police officer): No no, not now. ( She takes the",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "bottle from him.) (They soon arrive at the Old Town Mental Hospital. Spiros is asked to sit down in a wheelchair and is lead through a series of electronically",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "locked doors to room 6.  He rises from the wheelchair and looks around. Soon a female nurse comes in to the room and sits down with him by a",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "SPIROS: Butterfly! BUTTERFLY: (Seriously.) Hello. So. (She lays a notebook and a pen on the table.) For us to be able to help you you must tell us everything",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "about how you got here. SPIROS: I come from elsewhere. I’m here on a quick visit. The doors of time have been opened. We channel-hopped around the",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "spell of the historydream. BUTTERFLY:  (Taking  notes.)  You  feel  you  don’t  belong  in  this SPIROS: 1-o to you. (Butterfly twinkles with her eyes. ) SPIROS: 2-o and it’s a tie.",
    source: "The Mushroom Seamstress, Page 125"
  },
  {
    text: "BUTTERFLY: Have you taken any drugs? SPIROS: Never in my life. I’m a good little boy. I have, however, taken the entirety of DNA that has ever existed, all at once. ( He",
    source: "The Mushroom Seamstress, Page 125"
  },
];

// Function to get a random passage
export const getRandomPassage = () => {
  const randomIndex = Math.floor(Math.random() * featuredPassages.length);
  return featuredPassages[randomIndex];
};
